import { render, staticRenderFns } from "./ViewPopover.vue?vue&type=template&id=5618cee8&scoped=true&"
import script from "./ViewPopover.vue?vue&type=script&lang=js&"
export * from "./ViewPopover.vue?vue&type=script&lang=js&"
import style0 from "./ViewPopover.vue?vue&type=style&index=0&id=5618cee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618cee8",
  null
  
)

component.options.__file = "ViewPopover.vue"
export default component.exports